import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthShell } from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Mot de passe oublié" subtitle="Nous vous enverrons un lien de réinitialisation">
      {sent ? (
        <div className="text-center py-4">
          <MailCheck className="mx-auto text-emerald-500 mb-3" size={44} />
          <p className="text-sm text-muted-foreground">Si un compte existe pour <b>{email}</b>, un lien de réinitialisation a été généré. (Consultez les logs serveur en mode démo.)</p>
          <Link to="/login" className="inline-flex mt-5 text-primary font-semibold hover:underline">Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <Input type="email" placeholder="Votre email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          <Button type="submit" disabled={loading} className="w-full h-11 font-semibold" data-testid="forgot-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Envoyer le lien"}
          </Button>
          <p className="text-sm text-center text-muted-foreground"><Link to="/login" className="text-primary hover:underline">Retour</Link></p>
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token");
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/reset-password", { token, password }); toast.success("Mot de passe réinitialisé !"); navigate("/login"); }
    catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Nouveau mot de passe">
      <form onSubmit={submit} className="space-y-3">
        <Input type="password" placeholder="Nouveau mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" />
        <Button type="submit" disabled={loading || !token} className="w-full h-11 font-semibold" data-testid="reset-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : "Réinitialiser"}
        </Button>
      </form>
    </AuthShell>
  );
}
